"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getSignedUrlsQuery = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getSignedUrlsQuery = "\n    query GetSignedUrls($urlsConfig: [UrlConfig]!, $organisationId: String!) {\n        getS3SignedUrls(urlsConfig: $urlsConfig, organisationId: $organisationId)\n    }\n";
exports.getSignedUrlsQuery = getSignedUrlsQuery;

var _default = (0, _graphqlTag.default)(_templateObject(), getSignedUrlsQuery);

exports.default = _default;